import React, {useCallback} from 'react';
import {Button, FormControl, Popover} from 'react-bootstrap';
import CheckboxTree from 'react-checkbox-tree';

import {SB_ENTER_KEY_CODE} from '../../../../../Constants';
import {KeyboardUtils} from '../../../../../Utils';

import {useAddColumnController} from '../../../../../Hooks/QueryToolColumnHooks';

export const AddColumnPopover = React.forwardRef(({saveNewColumns, cancelAdd}, ref) => {
    const {
        checked,
        expanded,
        nodesFiltered,
        filterText,
        handleFilterChange,
        handleCheck,
        handleExpand,
        handleSave,
        placeholderGuid,
    } = useAddColumnController({saveNewColumns});

    const handlePopoverKeyDown = useCallback((event) => {
        KeyboardUtils.handleKeyPress(SB_ENTER_KEY_CODE, event, handleSave);
    }, [handleSave]);

    return (
        <Popover
            ref={ref}
            id={`sb-query-column-add-popup-${placeholderGuid}`}
            placement="bottom"
            onKeyDown={handlePopoverKeyDown}
        >
            <div className="popover-title shadow-bottom">
                <label className="sb-query-input-labels">Column Source</label>
                <FormControl
                    type="text"
                    value={filterText}
                    onChange={handleFilterChange}
                    placeholder="Type to search"
                    autoFocus
                />
            </div>
            <div className="popover-content">
                <CheckboxTree
                    nodes={nodesFiltered}
                    checked={checked}
                    expanded={expanded}
                    onCheck={handleCheck}
                    onExpand={handleExpand}
                    showNodeIcon={false}
                    icons={{
                        check: <img src="/img/box-checked.svg" alt="checked" />,
                        uncheck: <img src="/img/box-unchecked.svg" alt="unchecked" />,
                        halfCheck: <img src="/img/box-altchecked.svg" alt="indeterminate" />,
                        expandClose: <img src="/img/right-caret.svg" width={12} height={12} alt="expand" />,
                        expandOpen: <img src="/img/down-caret.svg" width={12} height={12} alt="collapse" />,
                        expandAll: null,
                        collapseAll: null,
                        parentClose: null,
                        parentOpen: null,
                        leaf: null,
                    }}
                />
            </div>
            <div className="popover-footer btn-edit shadow-top justify-right">
                <Button variant="cancel" onClick={cancelAdd}>Cancel</Button>
                <Button
                    variant="save"
                    onClick={handleSave}
                >
                    {checked.length > 1 ? 'Add Columns' : 'Add Column'}
                </Button>
            </div>
        </Popover>
    );
});
